var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},_vm._l((_vm.userGroupList),function({ id, name },index){return _c('span',{key:id},[_c('a',{class:_vm.$style.link,attrs:{"href":_vm.href({ id }),"target":"_self"},on:{"click":_vm.closeModal}},[_vm._v(_vm._s(name))]),_vm._v(_vm._s(_vm.getSeparator(index))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }